export const courierName = (key) => {
  switch (String(key)) {
    case "THP":
      return {name: "EMS"};
    case "CJLX":
      return {name: "CJLogisticShopX"};
    case "FLE":
      return {name: "Flash Express"};
    case "FLEWP":
      return {name: "Flash Express"};
    case "SCG":
      return {name: "SCG Express"};
    case "JNT":
      return {name: "JAndTExpress"};
    case "ECP":
      return {name: "eCo-Post"};
    case "TRUE":
      return {name: "True e-Logistic"};
    case "BEE":
      return {name: "BEE Express"};
    case "NJV":
      return {name: "Ninjavan"};
    case "SCGC":
      return {name: "SCG Yamato Express Chilled"};
    case "SCGF":
      return {name: "SCG Yamato Express Frozen"};
    case "TP2":
      return {name: "Thaipost Registered"};
    case "EMST":
      return {name: "EMS W-ST"};
    case "BEST":
      return {name: "BEST Express"};
    case "TPSD":
      return {name: "Teleport"};
    case "MSE":
      return {name: "Makesend Express"};
    case "MSEC":
      return {name: "Makesend Express Chilled"};
    case "SPE":
      return {name: "Shippop Express"};
    case "SPEC":
      return {name: "Shippop Express Cool"};
    case "KRYS":
      return {name: "Kerry Express"};
    case "KRYQ":
      return {name: "Quick Express"};
    case "EMSXP":
      return {name: "SPRESS"};
    default:
      return {name: ""};
  }
};

export const courierList = [
  {value: "THP", text: "EMS"},
  {value: "CJLX", text: "CJLogisticShopX"},
  {value: "FLE", text: "Flash Express"},
  {value: "SCG", text: "SCG Express"},
  {value: "JNT", text: "JAndTExpress"},
  {value: "ECP", text: "eCo-Post"},
  {value: "BEE", text: "BEE Express"},
  {value: "NJV", text: "Ninjavan"},
  {value: "SCGC", text: "SCG Yamato Express Chilled"},
  {value: "SCGF", text: "SCG Yamato Express Frozen"},
  {value: "TP2", text: "Thaipost Registered"},
  {value: "EMST", text: "EMS W-ST"},
  {value: "BEST", text: "BEST Express"},
  {value: "TPSD", text: "Teleport"},
  {value: "MSE", text: "Makesend Express"},
  {value: "MSEC", text: "Makesend Express Chilled"},
  {value: "SPE", text: "Shippop Express"},
  {value: "SPEC", text: "Shippop Express Cool"},
  {value: "KRYS", text: "Kerry Express"},
  {value: "KRYQ", text: "Quick Express"},
  {value: "EMSXP", text: "SPRESS"},
];
